import { createWidgetMixin } from 'vue-instantsearch';
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';

Vue.component('ais-dropdown', {
  template: "#ais-dropdown",
  mixins: [
    createWidgetMixin({ connector: connectCurrentRefinements }),
  ],
  props: {
    title: {
      type: String,
      required: true
    },
    defaultOpen: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '0'
    },
    windowPadding: {
      type: Number,
      default: 10
    },
    show: {
      type: Boolean,
      default: true
    },
    showWhenIsRefined: {
      type: Boolean,
      default: false
    },
    includedAttributes: Array,
    excludedAttributes: Array,
    transformItems: Function,
  },
  data () {
    return {
      open: this.defaultOpen,
      offsetLeft: 0,
      resizeObserver: null,
      helper: null
    }
  },
  methods: {
    handleResize () {
      if (this.$refs.content === undefined) return

      const rect = this.$refs.content.getBoundingClientRect()
      const rightDistance = window.innerWidth - (rect.left + rect.width)

      this.offsetLeft = Math.min(0, this.offsetLeft + rightDistance - this.windowPadding)
    },
    handleClickOutside (event) {
      if (!(this.$el == event.target || this.$el.contains(event.target))) {
        this.hide();
      }
    },
    hide () {
      this.open = false
    }
  },
  computed: {
    widgetParams () {
      return {
        includedAttributes: this.includedAttributes,
        excludedAttributes: this.excludedAttributes,
        transformItems: this.transformItems
      };
    },
    canRefine () {
      const includedAttributes = this.includedAttributes || [];
      const excludedAttributes = this.excludedAttributes || [];
      const stats = this.helper?.lastResults?.facets_stats;

      if (!stats) return true; // Return true initially to prevent flickering

      return Object.entries(stats).reduce((sum, [attribute, { total_values }]) => {
        return includedAttributes.includes(attribute) && !excludedAttributes.includes(attribute)
          ? sum + total_values
          : sum;
      }, 0) > 0;
    },
    refinedItems () {
      return this.state?.items ?? []
    },
    isRefined () {
      return this.refinedItems.length > 0
    },
    totalRefinementCount () {
      return this.refinedItems.reduce((acc, item) => acc + item.refinements.length, 0)
    }
  },
  watch: {
    state (state) {
      this.helper = state?.instantSearchInstance?.mainIndex?.getHelper();
    }
  },
  mounted () {
    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this.$refs.content)
    window.addEventListener('resize', this.handleResize)
    document.body.addEventListener('click', this.handleClickOutside)

    this.handleResize()
  },
  beforeDestroy () {
    this.resizeObserver.disconnect()
    document.body.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('resize', this.handleResize)
  }
});
